module.exports = __webpack_public_path__ + "img/vipIcon.1beb69fa.png";